export default __webpack_public_path__ + "static/media/output-onlinepngtools.a4c7300d.png";